import { useState, useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, EffectFade, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

import Image from "./Image";

export default function Gallery({ media, width, height }) {
	const swiperRef = useRef(null);

	if (!media || media.length === 0) return null;

	const aspectRatio = width && height ? width / height : 16 / 9;

	return (
		<Swiper
			modules={[Pagination, EffectFade, Autoplay]}
			pagination={{ clickable: true }}
			effect="fade"
			fadeEffect={{ crossFade: true }}
			slidesPerView={1}
			spaceBetween={0}
			grabCursor={true}
			autoplay={{
				delay: 3000,
				disableOnInteraction: false,
				pauseOnMouseEnter: true,
			}}
			onSwiper={(s) => (swiperRef.current = s)}
			className="scope-gallery-swiper"
			style={{
				aspectRatio: `${aspectRatio}`,
				width: "100%",
			}}
		>
			{media.map((slide, index) => (
				<SwiperSlide key={index}>
					<Image 
						src={slide.img_src || []} 
						width={width} 
						height={height} 
						alt={slide.img_alt || ''} 
					/>
				</SwiperSlide>
			))}
		</Swiper>
	);
}
